import { render, staticRenderFns } from "./VerifyCheckHeader.vue?vue&type=template&id=4994afe0&scoped=true&"
import script from "./VerifyCheckHeader.vue?vue&type=script&lang=js&"
export * from "./VerifyCheckHeader.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCheckHeader.vue?vue&type=style&index=0&id=4994afe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994afe0",
  null
  
)

export default component.exports